import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ItineraryService } from '../../../core/services/itinerary.service';
import { FormBuilder, Validators } from '@angular/forms';
import { SETTINGS } from '../../../core/config/common.settings';
import { AppUtils } from '../../../core/config/app.utils';
import { FileService } from '../../../core/services/file.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

@Component({
  selector: 'app-add-edit-customer-information',
  templateUrl: './add-edit-customer-information.component.html',
  styleUrls: ['./add-edit-customer-information.component.scss']
})
export class AddEditCustomerInformationComponent implements OnInit, OnDestroy {
  @Input() singleItinerary: any;
  customerForm: any;
  costingForm: any;
  formErrors: any;
  files: File[] = [];
  uploadAndPreview = true;
  placeholderPath: any = "../assets/img/placeholder-image.png";
  loading = false;
  costingType: any[] = [];
  private langChangeSub?: Subscription;

  constructor(private itineraryService: ItineraryService, private fb: FormBuilder,
              private modal: NzModalRef,
              private fileService: FileService,
              private translocoService: TranslocoService) {
    this.formErrors = {
      companyName: {},
      logo: {},
      websiteLink: {},
      summary: {},
    };
  }


  private getViewTypeB2BOptions(): Array<{ value: string; label: string }> {
    const lang = this.translocoService.getActiveLang();
    const f = SETTINGS.VIEW_TYPES_B2B.filter(i => i.language === lang);
    return (f.length ? f : SETTINGS.VIEW_TYPES_B2B.filter(i => i.language === 'en'))
      .map(({ value, label }) => ({ value, label }));
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }
  ngOnInit(): void {
    this.costingType = this.getViewTypeB2BOptions();
    this.langChangeSub = this.translocoService.langChanges$.subscribe(() => {
      this.costingType = this.getViewTypeB2BOptions();
    });
    this.costingForm = this.fb.group({
      viewType: ["person"],
      personCost: [0],
      grandTotal: [0],
      costPerAdult: [0],
      costPerChild: [0],
      costPerInfant: [0],
    });
    this.customerForm = this.fb.group({
      logo: [""],
      companyName: [""],
      summary: [""],
      websiteLink: ["", [Validators.pattern(SETTINGS.REGEX.URL.EXP)]],
    });
    this.customerForm.valueChanges.subscribe(() => {
      AppUtils.getFormErrors(this.customerForm, this.formErrors);
    });

    this.customerForm.patchValue({...this.singleItinerary.b2b.customer});
    this.costingForm.patchValue({...this.singleItinerary.b2b.costing});

  }

  onSelect(event: any): void {
    this.loading = true;
    this.files.push(...event.addedFiles);
    this.fileService.postFile(this.files[0]).subscribe(res => {
      this.customerForm.get("logo").setValue(res.url);
      this.uploadAndPreview = true;
      this.loading = false;
    });
  }

  onRemove(event: any): void {
    this.files.splice(this.files.indexOf(event), 1);
    this.customerForm.get("logo").setValue("");
  }

  async updateB2B(): Promise<void> {
    this.loading = true;
    const updatePayload = {
      time: this.singleItinerary?.b2b?.time,
      customer: this.customerForm.getRawValue(),
      costing: {...this.costingForm.getRawValue()},
    };
    try {
      await this.itineraryService.updateB2BItinerary({
        _id: this.singleItinerary._id,
        b2b: updatePayload,
      });

      localStorage.setItem("cs", JSON.stringify({customer: this.customerForm.getRawValue(),
        costing: {...this.costingForm.getRawValue()}
      })); // all forms

      this.loading = false;
      this.modal.close({status: "success"});
    } catch (e) {
      this.loading = false;
      this.modal.close({status: "close"});
    }
  }

  handleCancel(): void {
    this.modal.close({status: "close"});
  }

  isDataExistLocal(name: string): boolean {
    const data = localStorage.getItem(name);
    return data !== null;
  }

  patchCompanyInformationFromLocal(name: string): void {
    const userString: any = localStorage.getItem(name);
    const data = JSON.parse(userString);
    this.customerForm.patchValue(data?.customer || {});
  }

  patchCostingFromLocal(name: string): void {
    const userString: any = localStorage.getItem(name);
    const data = JSON.parse(userString);
    this.costingForm.patchValue(data?.costing || {});
  }
}
